import React from "react";
import VehicleHero from "./VehicleHero";
import VehicleTrustBar from "./VehicleTrustBar";
import VehicleBenefits from "./VehicleBenefits";
import VehicleHowItWorks from "./VehicleHowItWorks";
import VehicleLoginSample from "./VehicleLoginSample";
import VehicleCompliance from "./VehicleCompliance";
import VehicleCta from "./VehicleCta";
import Footer from "../../components/Footer/Footer";
import { PageWrapper } from "./VehicleLanding.elements";
import SEOHelmet from "../../components/SEOHelmet/SEOHelmet";

const vehicleStructuredData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Vehicle History Verification Nigeria",
  "serviceType": "Vehicle Background Check",
  "provider": {
    "@type": "Organization",
    "name": "e-citizen",
    "url": "https://e-citizen.ng"
  },
  "description": "Verify vehicle ownership, accident history, theft records, and car registration details for any Nigerian vehicle. Check VIN and plate number history before buying a car.",
  "areaServed": {
    "@type": "Country",
    "name": "Nigeria"
  },
  "url": "https://e-citizen.ng/vehicle-verification"
};

const VehicleVerificationPage = () => {
  return (
    <PageWrapper>
      <SEOHelmet
        title="Vehicle History Check Nigeria – Verify Car Ownership & Registration | e-citizen"
        description="Check any vehicle's history in Nigeria: ownership, accident records, theft status, and registration details. Verify a car by VIN or plate number before buying. Instant results."
        canonical="/vehicle-verification"
        keywords="vehicle verification Nigeria, car history check Nigeria, VIN verification Nigeria, plate number check Nigeria, car ownership check, verify vehicle Nigeria"
        structuredData={vehicleStructuredData}
      />
      <VehicleHero />
      <VehicleTrustBar />
      <VehicleBenefits />
      <VehicleHowItWorks />
      <VehicleLoginSample />
      <VehicleCompliance />
      <VehicleCta />
      <Footer />
    </PageWrapper>
  );
};

export default VehicleVerificationPage;

